<div class="flex space-between" *ngIf="showMobileFilters">
  <span class="heading-2 break-word">{{ 'general.api_event_search_filters' | translate }}</span>
  <div class="align-right">
    <button mat-button class="icon-button" (click)="toggleFilters()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
</div>
<div class="heading-1" *ngIf="!showMobileFilters">{{'general.api_menu_transactions' | translate}}</div>
<form #searchForm="ngForm" class="filter filter-mobile-no-border no-print" (ngSubmit)="isFormValid && applySearch()">
  <app-loader [loading]="updatingData || isLoading" [filterOverlay]="true" [size]="64"></app-loader>
  <div class="mobile-search mobile flex flex-grow flex-filters">
    <!-- MOBILE DATE RANGE -->
    <app-datepicker [(dateStart)]="filters.dateStart" [(dateEnd)]="filters.dateEnd"
                    [datePickerConfig]="dateRangeConfigMobile" (dateChanged)="!showMobileFilters && applyMobileDateChange()"
                    (dateTimeChanged)="validateDateRange()"
                    [valid]="!filters.dateStart || !filters.dateEnd || isDateRangeValid"
                    [ngClass]="{'bottom-spacer': showMobileFilters && utilService.isMobile}"></app-datepicker>
    <button type="button" *ngIf="!showMobileFilters" mat-button class="icon-button input-button mobile" (click)="toggleFilters()">
      <mat-icon class="svg-icon" [svgIcon]="'filters'"></mat-icon>
    </button>
  </div>
  <div class="flex flex-filters flex-wrap" [ngClass]="{'desktop' : !showMobileFilters || !utilService.isMobile, 'flex-column-mobile with-footer' : utilService.isMobile && showMobileFilters}">
    <!-- DATE RANGE -->
    <app-datepicker [(dateStart)]="filters.dateStart" [(dateEnd)]="filters.dateEnd" (dateTimeChanged)="validateDateRange()"
                    [valid]="!filters.dateStart || !filters.dateEnd || isDateRangeValid"
                    [datePickerConfig]="dateRangeConfig" class="desktop"></app-datepicker>
    <!-- TICKET ID -->
    <app-numeric-input [label]="'general.api_reports_ticket_id'" [(value)]="filters.ticketId" [ignoreMax32]="true"></app-numeric-input>
    <!-- TRANSACTION ID -->
    <app-numeric-input [label]="'general.api_reports_transaction_id'" [(value)]="filters.transactionId" [ignoreMax32]="true"></app-numeric-input>
    <!-- TRANSACTION TYPE -->
    <mat-form-field appearance="outline" class="no-hint" *ngIf="!legacyFilters">
      <mat-label>{{'general.api_transactions_type' | translate}}</mat-label>
      <mat-select [(ngModel)]="filters.transactionType" [ngModelOptions]="{standalone: true}">
        <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
        <mat-option *ngFor="let transactionType of transactionTypes" [value]="transactionType">
          {{ 'general.api_transactions_type_' + transactionType.toLowerCase() | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- REFERENCE NR -->
    <app-numeric-input *ngIf="legacyFilters && authService.checkPrivileges(Privileges.VIEW_INTERNET_TRANSACTIONS)"
                       [label]="'general.api_reports_reference_number'" [(value)]="filters.referenceNumber" [ignoreMax32]="true"></app-numeric-input>
    <div class="flex flex-flat">
      <!-- EVENT STATUS -->
      <mat-form-field appearance="outline" class="no-hint prefix-field condensed">
        <mat-label>{{'general.api_reports_event_status' | translate}}</mat-label>
        <mat-select [(ngModel)]="eventStatusId" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{displayFilterSelectedOption(eventStatusId, legacyFilters ? eventStatusesLegacy : eventStatuses) | translate}}</mat-select-trigger>
          <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
          <mat-option *ngFor="let status of legacyFilters ? eventStatusesLegacy : eventStatuses" [value]="status.id">
            {{status.name | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- EVENT NAME -->
      <app-scroll-load [label]="'general.api_reports_event_name'" [minInput]="3" [withPrefix]="true" [clearOnBlur]="true"
                       [customFilters]="{statusIds: [eventStatusId], eventType: legacyFilters ? EventType.Ybo : EventType.Bo3}"
                       [searchService]="eventService" [scrollLoad]="eventScrollLoad"
                       [(selectedObjectId)]="filters.eventId"></app-scroll-load>
    </div> 
    <!-- PAYMENT TYPE -->
    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>{{'general.api_reports_payment_type' | translate}}</mat-label>
      <mat-select [(ngModel)]="filters.paymentType" [ngModelOptions]="{standalone: true}" (ngModelChange)="filters.paymentMethod = null">
        <mat-select-trigger>{{('general.api_cart_' + filters.paymentType) | translate}}</mat-select-trigger>
        <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
        <mat-option *ngFor="let paymentType of (legacyFilters ? paymentTypesLegacy : paymentTypes)" [value]="paymentType">
          {{('general.api_cart_' + paymentType) | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- PAYMENT METHOD -->
    <ng-container *ngIf="!legacyFilters && filters.paymentType === PaymentTypeEnum.Transfer">
      <mat-form-field appearance="outline" class="no-hint">
        <mat-label>{{'general.api_transactions_payment_method' | translate}}</mat-label>
        <mat-select [(ngModel)]="filters.paymentMethod" [ngModelOptions]="{standalone: true}">
          <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
          <mat-option *ngFor="let paymentMethod of paymentMethods" [value]="paymentMethod">
            {{('general.api_transactions_payment_method_' + paymentMethod) | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="legacyFilters">
      <!-- BUYER -->
      <app-scroll-load [label]="'general.api_reports_buyer'" [minInput]="2"
                        [(fieldValue)]="filters.customerEmail"
                        [searchService]="customerService" [scrollLoad]="customerScrollLoad"
                        [(selectedObjectId)]="filters.customerUuid" (selectedObjectChange)="updateCustomer($event)"></app-scroll-load>
      <!-- BUYER E-MAIL -->
      <app-text-input [type]="TextInputType.Email"
                      [label]="'general.api_reports_sent_from_bo_email'" [(value)]="filters.sentFromBoEmail"></app-text-input>
      <!-- SELF-SERVICE EMAIL -->
      <app-text-input *ngIf="!legacyFilters" [type]="TextInputType.Email"
                      [label]="'general.api_transactions_email'" [(value)]="filters.email"></app-text-input>
    </ng-container>
    <!-- SELF-SERVICE EMAIL OR BUYER -->
    <app-scroll-load *ngIf="!legacyFilters" [label]="'general.api_transactions_buyer_or_delivery_email'" [minInput]="2"
                      [(fieldValue)]="filters.email"
                      [searchService]="customerService" [scrollLoad]="customerScrollLoad" (clearEvent)="filters.email = ''"
                      [(selectedObjectId)]="filters.buyerUuid" (selectedObjectChange)="updateBuyer($event)"></app-scroll-load>
    <!-- INVOICE NR -->
    <app-numeric-input [label]="'general.api_reports_invoice_number'" [(value)]="filters.invoiceNumber" [ignoreMax32]="true"></app-numeric-input>
    <!-- POINT OF SALE -->
    <mat-form-field appearance="outline" class="no-hint" *ngIf="salespoints?.length">
      <mat-label>{{ 'general.api_reports_salespoint' | translate }}</mat-label>
      <mat-select (selectionChange)="updateData(filters.transactionSalespointId)"
                  [(ngModel)]="filters.transactionSalespointId" [ngModelOptions]="{standalone: true}">
        <mat-select-trigger>{{displayFilterSelectedOption(filters.transactionSalespointId, salespoints)}}</mat-select-trigger>
        <mat-option>
          <app-select-search [values]="salespoints" [filterBy]="['name']" (filteredValues)="salespointsFiltered.next($event.slice())"></app-select-search>
        </mat-option>
        <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
        <mat-option *ngFor="let salespoint of salespointsFiltered | async" [value]="salespoint.id">
          {{ salespoint.name | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- SELLER -->
    <mat-form-field appearance="outline" class="no-hint">
      <mat-label>{{'general.api_reports_seller' | translate}}</mat-label>
      <mat-select [(ngModel)]="filters.sellerUuid" [ngModelOptions]="{standalone: true}">
        <mat-select-trigger>{{displayFilterUserName(filters.sellerUuid, sellers)}}</mat-select-trigger>
        <mat-option [value]="null" [disabled]="!filters.transactionSalespointId">
          <ng-container *ngIf="filters.transactionSalespointId">&nbsp;-&nbsp;</ng-container>
          <ng-container *ngIf="!filters.transactionSalespointId">
            {{'general.api_reports_choose_salespoint' | translate}}
          </ng-container>
        </mat-option>
        <mat-option *ngFor="let seller of sellers" [value]="seller.userId">
          {{seller.firstName}} {{seller.lastName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- RELEASE TYPE -->
    <ng-container *ngIf="legacyFilters">
      <mat-form-field appearance="outline" class="no-hint">
        <mat-label>{{'general.api_reports_release_type' | translate}}</mat-label>
        <mat-select [(ngModel)]="filters.releaseType" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{('general.api_cart_release_method_' + filters.releaseType) | translate}}</mat-select-trigger>
          <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
          <mat-option *ngFor="let releaseType of releaseTypes" [value]="releaseType">
            {{('general.api_cart_release_method_' + releaseType) | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <!-- EVENT OWNER TRANSACTIONS -->
    <mat-form-field appearance="outline" class="no-hint" *ngIf="hasEventOwnerTransactionsRights && !legacyFilters">
      <mat-label>{{ 'general.api_transaction_owner_type' | translate }}</mat-label>
      <mat-select [(ngModel)]="filters.searchEventOwnerTransactions" [ngModelOptions]="{standalone: true}">
        <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
        <mat-option [value]="true">{{ 'general.api_event_owner_transactions' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="flex flex-end desktop">
      <button mat-button type="button" (click)="clearFilters()">
        {{ 'general.api_general_clear' | translate }}
      </button>
      <button type="submit" mat-flat-button color="primary" [disabled]="!isFormValid">
        {{ 'general.api_search_transactions' | translate }}
      </button>
    </div>
    <footer *ngIf="showMobileFilters" class="mobile">
      <mat-dialog-actions>
        <button mat-button type="button" (click)="clearFilters()">
          {{ 'general.api_general_clear' | translate }}
        </button>
        <button type="submit" mat-flat-button color="primary" [disabled]="!isFormValid">
          {{ 'general.api_search_transactions' | translate }}
        </button>
      </mat-dialog-actions>
    </footer>
  </div> 
</form>
<ng-container *ngIf="(!showMobileFilters || !utilService.isMobile) && !isLoading && !hasResults">
  <hr class="slim mobile bottom-spacer-x2">
  <div class="heading-2 desktop">{{ 'general.api_search_results' | translate }}</div>
  <div class="body-2 text-muted">
    <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
    {{ (noSearches ? 'general.api_reports_choose_filter' : 'general.api_transactions_empty') | translate }}
  </div>
</ng-container>
